import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { withLocalization } from 'hocs/localization'
import { hiddenUnmountedModal } from 'hocs/hiddenUnmountedModal'
import { closeModal } from 'redux-app/modules/modals'
import { getModalDataByName } from 'redux-app/selectors/modals'
import ConfirmChangingPlanModal from './ConfirmChangingPlanModal'
import { MODAL_CONFIRM_CHANGING_PLAN } from './constants'

export default compose(
  hiddenUnmountedModal(MODAL_CONFIRM_CHANGING_PLAN),
  withLocalization('profile.manageAccount'),
  withRouter,
  connect(
    state => {
      const { upgradeFee, downgradeFee } = getModalDataByName(state, { name: MODAL_CONFIRM_CHANGING_PLAN })
      return {
        upCharged: upgradeFee,
        downCharged: downgradeFee,
      }
    },
    {
      closeModal,
    },
  ),
  withHandlers({
    onClose: ({ closeModal }) => () => closeModal({ name: MODAL_CONFIRM_CHANGING_PLAN }),
    goToPlans: ({ history: { push }, closeModal }) => () => {
      closeModal({ name: MODAL_CONFIRM_CHANGING_PLAN })
      push(ROUTES.profile.changePlan.root)
    },
  }),
)(ConfirmChangingPlanModal)
